import { useCallback, useState } from "react";
import { Switch } from "../../../components/inputs/Switch";
import { adminApi, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";

export const LabReflexToPAToggle = ({ clinicLabPermission, labName, reflexToPa, onChange, readOnly, onError }) => {
  const [loading, setLoading] = useState(false);
  const label = loading ? "Loading..." : reflexToPa ? "Yes" : "No";

  const getUpdateMessage = useCallback((reflexToPa) => `Set Reflex To PA for lab ${labName} as ${reflexToPa ? "Yes" : "No"}`, [labName]);

  const handleChange = useCallback(
    async (e) => {
      setLoading(true);
      const reflexToPa = e.target.checked;

      try {
        await adminApi.put(`/admin/clinic_lab_permissions/${clinicLabPermission.id}`, snakifyKeys({ reflexToPa: reflexToPa }));

        onChange(getUpdateMessage(reflexToPa));
      } catch (err) {
        onError(extractErrorMessage(err));
      } finally {
        setLoading(false);
      }
    },
    [clinicLabPermission, onChange, onError, getUpdateMessage]
  );

  return (
    <Switch
      disabled={readOnly || loading}
      id={`reflex_to_pa${clinicLabPermission.id}`}
      checked={Boolean(reflexToPa)}
      label={label}
      onChange={handleChange}
    />
  );
};
